<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<keep-alive>
				<search search_type="document"></search>
				</keep-alive>
				 
				 <!-- 主体列表内容 -->
				 <div class="proDocument">
					 <div class="conmonDocument bd10">
						 <ul>
							 <li v-for="(item, index) in documentVOList" :key="index">
								 <div class="pdLeft">
									 <h3 class="font18 pdf d-flex"><a class="link" :href="item.file" target="_blank">{{item.title}}</a><span class="font-light cor999">{{item.releaseDate}}</span></h3>
									 <div class="lbot d-flex j-sb">
										<div class="tagList d-flex f-wrap">
											<i class="font14" v-for="(item2, index2) in item.subGroup ? item.subGroup.split(',') : []" :key="index2">{{item2}}</i>
										</div>
										<div class="rHandle d-flex a-center">
											<a  class="d" @click="downloadFile(item.id,index)"></a>
											<a  class="l" v-if="item.fileSuffix=='pdf'" @click="viewFile(item.id,index)"></a>
										</div>
										
									 </div>
									 <div class="downbar d-flex j-end" v-show="item.dp>0">
											<el-progress :percentage="item.dp" :show-text="true" :stroke-width="4"></el-progress>
										</div>
								 </div>
							 </li>
						 </ul>
					 </div>
					 <!-- 分页 -->
					 <div class="pagination">
						 <el-pagination
							   @current-change="handleCurrentChange"
							   :page-size="10"
							   layout="prev, pager, next"
							   :total="total">
						</el-pagination>
					 </div>
					 <el-dialog
						:title="pdfView.title"
						:visible.sync="pdfView.showPdf"
						:fullscreen="true"
						class="pdfdialog"
						top="0"
						width="100%">
						<div class="pdfview">
							<pdf v-for="i in pdfView.pages"
								:key="i"
								:src="pdfView.pdfBlob"
								:page="i">
							</pdf>
						</div>
					</el-dialog>
				 </div>
			</div>
		</div>
  </div>
</template>

<script>
// Search组件
import search from './component/search.vue';
import { pdfjs, Document } from 'pdfjs-dist/build/pdf';
import VuePDF from 'vue-pdf';
export default {
  name: 'ProductDocument',
  components: {
    search,
	pdf: VuePDF
  },
  data() {
    return {
		// 文档
		documentVOList: [],
		// 分页
		pagination: {
			contentType: 'document',
			pageNo: 1,
			pageSize: 10,
			productId: ''
		},
		// 数量
		total: 0,
		pdfView:{
			title:"",
			pages:undefined,
			pdfBlob:null,
			showPdf:false
		}
	}
  },
  
  created() {
  	this.pagination.productId = this.$route.query.productId;
  	// 获取文档
  	this.getDocumentVOList();
  },
  
  methods: {
	viewFile(id,index){
		var that=this;
		if(that.documentVOList[index].blob){
			that.pdfView.pdfBlob=url;
			let loadingTask = VuePDF.createLoadingTask(that.pdfView.pdfBlob);
			loadingTask.promise.then(pdf => {
				that.pdfView.pages = pdf.numPages;
			});
			that.pdfView.title=that.documentVOList[index].title;
			that.pdfView.showPdf=true;
			return;
		};
		const loading = that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
		that.$daxios
			.get(`knowledge/downLog?id=${id}`,{
			 	responseType: 'blob'
			})
			.then((res) => {
			loading.close();
			if(res.data&&res.data.size==0){
				that.$message({
					message:"下载失败",
					type: 'error'
				});
				return;
			};
			const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
			that.pdfView.pdfBlob=url;
			let loadingTask = VuePDF.createLoadingTask(that.pdfView.pdfBlob);
			loadingTask.promise.then(pdf => {
				that.pdfView.pages = pdf.numPages;
			});
			that.pdfView.title=that.documentVOList[index].title;
			that.pdfView.showPdf=true;
			})
			.catch((err) => { 
				loading.close();
				that.$message({
					message: '下载失败',
					type: 'warning'
				});
			});
	},
	downloadFile(id,index){
      var that=this;
      if(that.documentVOList[index].dp!=0){return;}
      that.$daxios
        .get(`knowledge/downLog?id=${id}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.documentVOList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
		if(res.data&&res.data.size==0){
            that.documentVOList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
		  that.documentVOList[index].blob=url;
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => { 
          console.log(err);
        });
    },
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  // 获取文档
	  getDocumentVOList() {
		  this.$axios.post(`product/otherPage`, this.pagination)
		  .then(res => {
			  let data = res.data;
			  data.list.forEach(i=>{i.dp=0;i.blob="";});
			  this.documentVOList = data.list;
			  this.total = data.total;
		  })
		  .catch(err=>{})
	  },
	  
	  // 点击翻页
	  handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getDocumentVOList();
	  }
  }
}
</script>

<style lang="less" scoped>
	.proDocument{
		.pdLeft{
			.tagList{
				margin-top: .2rem;
			}
			.rHandle{
				.d{
					width: .16rem;
					height: .16rem;
					background: url(@/assets/Icons/downloadGray.png) no-repeat center/100% 100%;
					margin-right: .3rem;
					&:hover{
						background-image: url(@/assets/Icons/downloadBlue.png);
					}
				}
				.l{
					width: .2rem;
					height: .15rem;
					background: url(@/assets/Icons/look.png) no-repeat center/100% 100%;
					&:hover{
						background-image: url(@/assets/Icons/lookBlue.png);
					}
				}
				a{
					&:last-child{
						margin-right: 0;
					}
				}
			}
		}
		.conmonDocument{
			ul li{
				h3{
					width: 100%;
					justify-content: space-between;
					min-height: 0.2rem;
					span {
						flex: 0 0 auto;
						padding-left: 2em;
						font-size: 0.8em;
						font-weight: normal;
					}
					a {
						flex: 1 1 auto;
						overflow: hidden;
					}
				}
				.identifying{
					padding: 5px;
					border: solid 1px #eee;
					border-radius: 3px;
				}
			}
		}
	}
	
	.conmonDocument{
		padding: .3rem;
		ul li{
			padding: .25rem 0;
			&:not(:last-child) {
				border-bottom: solid 1px #f1f1f1;
			}
			h3{
				width: 85%;
			}
		}
	}
</style>
